
export const Default = () => {
    return (
        <div style={{textAlign: 'center'}}>
            <h1>CrewCam App</h1>
        </div>
    )
}